module.exports = __webpack_public_path__ + "static/media/gymOverlayBg.f042c2ac.jpg";